import service from './request'

/**
 * 获工单优先级列表
 */
 export const orderPriorityGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/orderPriority/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加工单优先级信息
 */
 export const orderPriorityAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderPriority/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改工单优先级信息
 */
 export const orderPriorityUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderPriority/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除工单优先级信息
 */
 export const orderPriorityDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderPriority/delInfo',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/orderPriorityManagement.js